module.exports = __webpack_public_path__ + "bluecircle.cee13147.png";